var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 16.92V19.92C22.5011 20.1985 22.4441 20.4741 22.3325 20.7293C22.2209 20.9845 22.0573 21.2136 21.8521 21.4018C21.6469 21.5901 21.4046 21.7335 21.1408 21.8227C20.8769 21.9119 20.5974 21.945 20.32 21.92C17.2428 21.5856 14.287 20.5341 11.69 18.85C9.27383 17.3146 7.22534 15.2661 5.69 12.85C3.99998 10.2412 2.94824 7.27097 2.62 4.17997C2.59501 3.90344 2.62788 3.62474 2.7165 3.3616C2.80513 3.09846 2.94757 2.85666 3.13477 2.6516C3.32196 2.44653 3.54981 2.28268 3.80379 2.1705C4.05778 2.05831 4.33234 2.00024 4.61 1.99997H7.61C8.09531 1.9952 8.56579 2.16705 8.93376 2.48351C9.30173 2.79996 9.54208 3.23942 9.61 3.71997C9.73662 4.68004 9.97145 5.6227 10.31 6.52997C10.4445 6.8879 10.4737 7.27689 10.3939 7.65086C10.3142 8.02482 10.1289 8.36809 9.86 8.63998L8.59 9.90997C10.0136 12.4135 12.0865 14.4864 14.59 15.91L15.86 14.64C16.1319 14.3711 16.4752 14.1858 16.8491 14.1061C17.2231 14.0263 17.6121 14.0554 17.97 14.19C18.8773 14.5285 19.8199 14.7634 20.78 14.89C21.2658 14.9585 21.7094 15.2032 22.0265 15.5775C22.3437 15.9518 22.5122 16.4296 22.5 16.92Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.076db0c79b206013d50c6d71415fbdeb.svg";
export { ForwardRef as ReactComponent };